import { apiClient } from "./apiClient";

// Fetch weekly dashboard data
export async function fetchWeeklyDashboardApi({ workspaceId, start, end, token }) {
  return apiClient(`/dashboard/weekly?workspaceId=${workspaceId}&start=${start}&end=${end}`, {
    token,
    method: "GET",
  });
}

export async function addDayMarkerApi({ workspaceId, date, color, label, token }) {
  return apiClient("/dashboard/markers", {
    token,
    method: "POST",
    body: { workspaceId, date, color, label },
  });
}

export async function deleteDayMarkerApi({ workspaceId, date, token }) {
  return apiClient(`/dashboard/markers/${date}?workspaceId=${workspaceId}`, {
    token,
    method: "DELETE",
  });
}
